<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Partnerzy'" [name]="'Lista'"></app-breadcrumb>
<div class="partners-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="partners-list-filters">
    <mat-form-field class="partners-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dict
      [dictType]="'legal_form'" [label]="'Forma prawna'"
      class="partners-list-filter"
      [(ngModel)]="initialFilters.legalForm" name="legalForm"
    ></app-dict>

    <app-dict
      [multiple]="true" [dictType]="'form_of_business'"
      [label]="'Typ działalności'" class="partners-list-filter"
      [(ngModel)]="initialFilters.in$formOfBusiness" name="in$formOfBusiness"
    ></app-dict>

    <mat-form-field class="partners-list-filter">
      <mat-label>Pełna nazwa</mat-label>
      <input matInput placeholder="Pełna nazwa" name="contains$fullName" [(ngModel)]="initialFilters.contains$fullName">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>Nazwa skrócona</mat-label>
      <input matInput placeholder="Nazwa skrócona" name="contains$shortName" [(ngModel)]="initialFilters.contains$shortName">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="contains$nip" [(ngModel)]="initialFilters.contains$nip">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>REGON</mat-label>
      <input matInput placeholder="REGON" name="contains$regon" [(ngModel)]="initialFilters.contains$regon">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>KRS</mat-label>
      <input matInput placeholder="KRS" name="contains$krs" [(ngModel)]="initialFilters.contains$krs">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" name="email" [(ngModel)]="initialFilters.email">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="Numer telefonu" name="phone" [(ngModel)]="initialFilters.phone">
    </mat-form-field>

    <mat-form-field class="partners-list-filter">
      <mat-label>Nr rachunku</mat-label>
      <input matInput placeholder="Nr rachunku" name="contains$accountNumber" [(ngModel)]="initialFilters.contains$accountNumber">
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter">
      <mat-label>Płatnik VAT</mat-label>
      <mat-select [(ngModel)]="initialFilters.vatPayer" name="vatPayer">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'partner_status'"
      [label]="'Status'" class="partners-list-filter"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true" [label]="'Regionalny (majątek)'"
      class="partners-list-filter" [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (życie)'" class="partners-list-filter"
      [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
    ></app-dict-regionals>

<!--    <mat-form-field class="partners-list-filter">-->
<!--      <mat-label >Przypis do</mat-label>-->
<!--      <input matInput placeholder="lista" name="headers" [(ngModel)]="initialFilters.headers">-->
<!--    </mat-form-field>-->

    <mat-form-field class="partners-list-filter partners-list-filter-address">
      <mat-label>Adres</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo'" class="partners-list-filter"
      [(ngModel)]="initialFilters.state" name="state"
    ></app-dict>

    <app-dict
      class="partners-list-filter" [label]="'Tagi'"
      [dictType]="'partner_tags'"
      [required]="false" [multiple]="true"
      [(ngModel)]="initialFilters.tags" name="tags"
    ></app-dict>

<!--    <mat-form-field appearance="standard" class="partners-list-filter">-->
<!--      <mat-label>Rekord zweryfikowany</mat-label>-->
<!--      <mat-select [(ngModel)]="initialFilters.verified" name="verified">-->
<!--        <mat-option [value]="null">Wszyscy</mat-option>-->
<!--        <mat-option [value]="1">Tak</mat-option>-->
<!--        <mat-option [value]="0">Nie</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

<!--    <mat-form-field appearance="standard" class="partners-list-filter">-->
<!--      <mat-label>Samofakturowanie</mat-label>-->
<!--      <mat-select [(ngModel)]="initialFilters.selfBilling" name="selfBilling">-->
<!--        <mat-option [value]="null">Wszyscy</mat-option>-->
<!--        <mat-option [value]="1">Tak</mat-option>-->
<!--        <mat-option [value]="0">Nie</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="standard" class="partners-list-filter">
      <mat-label>Samofakturowanie ASF</mat-label>
      <mat-select [(ngModel)]="initialFilters.activeSelfBillingAsf" name="activeSelfBillingAsf">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter">
      <mat-label>Samofakturowanie ASF Premium</mat-label>
      <mat-select [(ngModel)]="initialFilters.activeSelfBillingPremium" name="activeSelfBillingPremium">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter" >
      <mat-label>Partner nowy</mat-label>
      <mat-select [(ngModel)]="initialFilters.newPartner" name="newPartner">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-datepicker
      class="partners-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="partners-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field appearance="standard" class="partners-list-filter" >
      <mat-label>Dostęp ASF360</mat-label>
      <mat-select [(ngModel)]="initialFilters.ASF360Access" name="ASF360Access">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter" >
      <mat-label>Weryfikacja procesu sprzedaży</mat-label>
      <mat-select [(ngModel)]="initialFilters.verificationSalesProcess" name="verificationSalesProcess">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter" >
      <mat-label>Aktualności marketingowe</mat-label>
      <mat-select [(ngModel)]="initialFilters.contestMessageConsent" name="contestMessageConsent">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="partners-list-filter" >
      <mat-label>Aktualności produktowe </mat-label>
      <mat-select [(ngModel)]="initialFilters.productMessageConsent" name="productMessageConsent">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div class="partners-list-buttons">
    <button *ngIf="(userPermissions | async).partner_additional.read_report" [disabled]="!(userPermissions | async)?.partner_additional.read_report"
            mat-raised-button [matMenuTriggerFor]="generateRegional" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generateRegional="matMenu">
      <button *ngIf="(userPermissions | async)?.partner_additional.read_report" [disabled]="!(userPermissions | async)?.partner_additional.read_report" mat-menu-item (click)="downloadReportRegional()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async)?.partner_additional.read_report" [disabled]="!(userPermissions | async)?.partner_additional.read_report" mat-menu-item (click)="openReportDialogRegional()">Pobierz raport niestandardowy</button>
    </mat-menu>

    <button *ngIf="(userPermissions | async).partner.read_report" [disabled]="!(userPermissions | async).partner.read_report"
            mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button *ngIf="(userPermissions | async).partner.read_report" [disabled]="!(userPermissions | async).partner.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).partner.read_report" [disabled]="!(userPermissions | async).partner.read_report" mat-menu-item (click)="openReportDialog()">Pobierz raport niestandardowy</button>
      <button *ngIf="(userPermissions | async).partner.admin_root" [disabled]="!(userPermissions | async).partner.admin_root"  mat-menu-item (click)="downloadReportAffiliateCode()">Pobierz raport kodów afiliacyjnych</button>

    </mat-menu>

    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="shortName"> Nazwa skrócona </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.uuid]">{{element.shortName ? element.shortName : "\<\brak nazwy\>"}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let email of element.emails">
          <span *ngIf="email.main ">{{email.address}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let phone of element.phones">
          <span *ngIf="phone.main">{{phone.number | phone}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element"> {{element.nip}} </td>
    </ng-container>

    <ng-container matColumnDef="regon">
      <th mat-header-cell *matHeaderCellDef > REGON </th>
      <td mat-cell *matCellDef="let element" > {{element.regon}} </td>
    </ng-container>

    <ng-container matColumnDef="headquartersAddress">
      <th mat-header-cell *matHeaderCellDef> Adres siedziby </th>
      <td mat-cell *matCellDef="let element">
        <app-table-address [address]="element.headquartersAddress"></app-table-address>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.assetsRegional">
            {{element.assetsRegional.firstName}} {{element.assetsRegional.lastName}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).partner.delete" mat-menu-item (click)="deletePartner(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
